import { render, staticRenderFns } from "./meansModel.vue?vue&type=template&id=3c39651c&scoped=true"
import script from "./meansModel.vue?vue&type=script&lang=js"
export * from "./meansModel.vue?vue&type=script&lang=js"
import style0 from "./meansModel.vue?vue&type=style&index=0&id=3c39651c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c39651c",
  null
  
)

export default component.exports